<div class="performance-page">

  <div class="page-header">

    <div>

      <div class="breadcrumb">
        HR Management / Performance
      </div>

      <h1>
        Performance
      </h1>

      <p>
        Track employee performance reviews and goals.
      </p>

    </div>

  </div>


  <div class="stats-grid">

    <mat-card class="stat-card">

      <div class="stat-icon primary">
        <mat-icon>assessment</mat-icon>
      </div>

      <div class="stat-info">
        <span>Average Rating</span>
        <strong>{{ avgRating | number:'1.1-1' }}</strong>
      </div>

    </mat-card>

    <mat-card class="stat-card">

      <div class="stat-icon success">
        <mat-icon>check_circle</mat-icon>
      </div>

      <div class="stat-info">
        <span>Completed</span>
        <strong>{{ completedReviews }}</strong>
      </div>

    </mat-card>

    <mat-card class="stat-card">

      <div class="stat-icon warning">
        <mat-icon>pending</mat-icon>
      </div>

      <div class="stat-info">
        <span>In Progress</span>
        <strong>{{ inProgressReviews }}</strong>
      </div>

    </mat-card>

    <mat-card class="stat-card">

      <div class="stat-icon purple">
        <mat-icon>star</mat-icon>
      </div>

      <div class="stat-info">
        <span>Total Reviews</span>
        <strong>{{ reviews.length }}</strong>
      </div>

    </mat-card>

  </div>


  <mat-card class="performance-card">

    <div class="card-header">

      <div>

        <h2>
          Performance Reviews
        </h2>

        <p>
          Employee reviews and ratings for current period
        </p>

      </div>

      <mat-form-field appearance="outline" class="search-field">

        <mat-label>
          Search reviews
        </mat-label>

        <input
          matInput
          [(ngModel)]="searchText"
          (ngModelChange)="filterReviews()"
          placeholder="Employee or department">

        <mat-icon matSuffix>
          search
        </mat-icon>

      </mat-form-field>

    </div>

    <mat-divider></mat-divider>

    <div class="table-container">

      <table
        mat-table
        [dataSource]="filteredReviews"
        class="performance-table">

        <ng-container matColumnDef="employee">
          <th mat-header-cell *matHeaderCellDef>
            Employee
          </th>
          <td mat-cell *matCellDef="let review">
            {{ review.employeeName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="department">
          <th mat-header-cell *matHeaderCellDef>
            Department
          </th>
          <td mat-cell *matCellDef="let review">
            {{ review.department }}
          </td>
        </ng-container>

        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>
            Period
          </th>
          <td mat-cell *matCellDef="let review">
            {{ review.reviewPeriod }}
          </td>
        </ng-container>

        <ng-container matColumnDef="rating">
          <th mat-header-cell *matHeaderCellDef>
            Rating
          </th>
          <td mat-cell *matCellDef="let review">
            <div class="rating-cell">
              <span class="rating-value" [style.color]="getRatingColor(review.rating)">
                {{ review.rating }}
              </span>
              <mat-progress-bar
                mode="determinate"
                [value]="review.rating * 20"
                [color]="review.rating >= 4 ? 'primary' : review.rating >= 3 ? 'warn' : 'warn'">
              </mat-progress-bar>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            Status
          </th>
          <td mat-cell *matCellDef="let review">
            <span
              class="status-badge"
              [class.completed]="review.status === 'Completed'"
              [class.inprogress]="review.status === 'In Progress'">

              {{ review.status }}

            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

    </div>

  </mat-card>

</div>
